import { render, staticRenderFns } from "./Analplug2.vue?vue&type=template&id=6530a6c4&scoped=true&"
import script from "./Analplug2.vue?vue&type=script&lang=js&"
export * from "./Analplug2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6530a6c4",
  null
  
)

export default component.exports